module.exports = __webpack_public_path__ + "img/19_53.311d73a7.png";